<template>
  <div>
    <p
      v-if="EVALUATION_STATUS.UNDER_EVALUATION === status"
      class="yellow--text text--darken-2"
    >
      Pending
    </p>

    <p v-else-if="EVALUATION_STATUS.CHALLENGED === status" class="red--text">
      Challenged
    </p>

    <p
      v-else-if="EVALUATION_STATUS.CHANGES_REQUESTED === status"
      class="orange--text"
    >
      Awaiting Professor's Response
    </p>
    <p v-else-if="EVALUATION_STATUS.COMPLETED === status" class="green--text">
      Quality Assessment Complete
    </p>
    <p v-else>
      -
    </p>
  </div>
</template>

<script>
import { EVALUATION_STATUS } from '@/utils/constants'

export default {
  name: 'EvaluationStatusDisplay',

  components: {},

  props: {
    status: {
      type: Number,
      default: null,
    },
  },

  computed: {
    EVALUATION_STATUS: () => EVALUATION_STATUS,
  },
}
</script>
